import { render } from "./TheTabsBarLang.vue?vue&type=template&id=6b10b386&scoped=true"
import script from "./TheTabsBarLang.vue?vue&type=script&lang=ts"
export * from "./TheTabsBarLang.vue?vue&type=script&lang=ts"

import "./TheTabsBarLang.vue?vue&type=style&index=0&id=6b10b386&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b10b386"

export default script